import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Navbar, Footer, Loading, Breadcrumbs } from "../../../components/shared";
import { Helmet } from "react-helmet-async";
import {
  uploadUserFamilyMemberMissingData,
} from '../../../service/UserFamilyApi';
import { getUserFamily } from "../../../service/UserApi";
import { useForm } from 'react-hook-form';
import { getCroppedImg, checkBase64Size, getYearOptions, getAge } from '../../../utils/Utilities';
import { UserFileUpload } from '../../file/gcp/FileUpload';
import Cropper from 'react-easy-crop';
import { useSelector } from "react-redux";
import '../../../pages/general/General.css';
import { businessNames } from '../../general/DropDownValuesConfig';
import useCheckLoggedin from "../../../utils/useCheckLoggedin";
function UserFamilyMissingInfoUpdate() {
  useCheckLoggedin();
  const [family, setFamily] = useState(null);
  const [familyMember, setFamilyMember] = useState(null);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const dateInputRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedYear, setSelectedYear] = useState("");
  // Photo crop states
  const [croppedImageBase64, setCroppedImageBase64] = useState(null);
  const [uploadMode, setUploadMode] = useState('both'); // 'none', 'both', 'applicationOnly'
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isAspectRatioLocked] = useState(true);
  const [imageFile, setImageFile] = useState(null);

  const imageURL = useMemo(() => imageFile ? URL.createObjectURL(imageFile) : null, [imageFile]);

  // Add separate useForm instances for each form
  const { register: registerMobile, handleSubmit: handleSubmitMobile, reset: resetMobile, formState: { errors: errorsMobile, isValid: isValidMobile, isSubmitting: isSubmittingMobile } } = useForm();
  const { register: registerMobile2, handleSubmit: handleSubmitMobile2, reset: resetMobile2, formState: { errors: errorsMobile2, isValid: isValidMobile2, isSubmitting: isSubmittingMobile2 } } = useForm();
  const { register: registerEmail, handleSubmit: handleSubmitEmail, reset: resetEmail, formState: { errors: errorsEmail, isValid: isValidEmail, isSubmitting: isSubmittingEmail } } = useForm();
  const { register: registerDOB, handleSubmit: handleSubmitDOB, reset: resetDOB, setValue: setValueDOB, formState: { errors: errorsDOB, isValid: isValidDOB, isSubmitting: isSubmittingDOB } } = useForm();
  useEffect(() => {
    const fetchData = async () => {
      const data = await getUserFamily(user.email);
      setFamily(data.family);
    };
    fetchData();
  }, [user.email]);

  useEffect(() => {
    if (familyMember) {
      resetMobile({ mobile: familyMember.mobile || "" });
      resetMobile2({ mobile2: familyMember.mobile2 || "" });
      resetEmail({ email: familyMember.email || "" });
      resetDOB({ dob: familyMember.dob || "" });
    }
  }, [familyMember]);
  const getBusinessLabel = (value) => {
    const item = businessNames.find(b => b.value === value);
    return item ? item.label : value || "";
  };
  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await getUserFamily(user.email);
      setFamily(data.family);
      const selectedMember = data.family.members.find(m => m.uid === familyMember?.uid);
      setFamilyMember(selectedMember || null);
    } catch (error) {
      alert("Failed to load family data.");
    } finally {
      setLoading(false);
    }
  };
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    const dateString = `${year}-06-01`;

    // Update both DOM and react-hook-form state
    if (dateInputRef.current) {
      dateInputRef.current.value = dateString;
    }
    setValueDOB("dob", dateString, { shouldValidate: true });
  };
  // Update handlers
  const updateMobile = async (data) => {
    setLoading(true);
    try {
      await uploadUserFamilyMemberMissingData({
        familyId: family.id,
        uid: familyMember.uid,
        mobile: data.mobile
      });
      setFamilyMember(prev => ({ ...prev, mobile: data.mobile }));
    } catch {
      alert("Failed to update mobile.");
    }
    resetMobile();
    await fetchData();
    setLoading(false);
  };
  const updateMobile2 = async (data) => {
    setLoading(true);
    try {
      await uploadUserFamilyMemberMissingData({
        familyId: family.id,
        uid: familyMember.uid,
        mobile2: data.mobile2
      });
      setFamilyMember(prev => ({ ...prev, mobile: data.mobile2 }));
    } catch {
      alert("Failed to update mobile.");
    }
    resetMobile2();
    await fetchData();
    setLoading(false);
  };
  const updateEmail = async (data) => {
    setLoading(true);
    try {
      await uploadUserFamilyMemberMissingData({
        familyId: family.id,
        uid: familyMember.uid,
        email: data.email
      });
      setFamilyMember(prev => ({ ...prev, email: data.email }));
    } catch {
      alert("Failed to update email.");
    }
    resetEmail();
    await fetchData();
    setLoading(false);
  };

  const updateDOB = async (data) => {
    setLoading(true);
    try {
      await uploadUserFamilyMemberMissingData({
        familyId: family.id,
        uid: familyMember.uid,
        dob: data.dob
      });
      setFamilyMember(prev => ({ ...prev, dob: data.dob }));
    } catch {
      alert("Failed to update DOB.");
    }
    resetDOB();
    await fetchData();
    setLoading(false);
  };

  const updatePhoto = async () => {
    if (!croppedImageBase64) return alert("Please crop the image first.");
    setLoading(true);
    try {
      const blob = await fetch(croppedImageBase64).then(res => res.blob());
      const file = new File([blob], `${familyMember.uid}.jpg`, { type: 'image/jpeg' });
      const photoPath = await UserFileUpload(file, 'family_member', 'photo', familyMember.uid);
      await uploadUserFamilyMemberMissingData({
        familyId: family.id,
        uid: familyMember.uid,
        photoPath
      });
      setFamilyMember(prev => ({ ...prev, photoPath }));
      setImageFile(null);
      setCroppedImageBase64(null);
    } catch {
      alert("Failed to update photo.");
    }
    await fetchData();
    setLoading(false);
  };
  const handleImageSelect = useCallback((e) => {
    const file = e.target.files[0];
    if (file) {
      const MAX_FILE_SIZE = 1000000; // 1 MB
      if (file.size > MAX_FILE_SIZE) {
        setErrorMessage('படத்தின் அளவு 1 MB க்கும் குறைவாக இருக்க வேண்டும்.');
        e.target.value = ''; // Clear the file input
        setImageFile(null); // Clear any previously set imageFile
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCroppedAreaPixels(null); // Clear any previously cropped image
        setCroppedImageBase64(null); // Clear any previously cropped image Base64
        setUploadMode('none');
      } else {
        setImageFile(file); // Store the selected file temporarily
        setUploadMode('both');
        setErrorMessage('');
      }
    } else {
      // If input is cleared, reset all related states
      setImageFile(null);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setCroppedAreaPixels(null);
      setCroppedImageBase64(null); // Clear any previously cropped image Base64
      setErrorMessage('');
      setUploadMode('none');
    }
  }, []);

  const onCropComplete = useCallback((_, newCroppedAreaPixels) => {
    setCroppedAreaPixels(newCroppedAreaPixels);
  }, []);


  const handleCrop = useCallback(async () => {
    if (!imageURL || !croppedAreaPixels) {
      setErrorMessage('Please select an image and define a crop area first.');
      return;
    }
    if (Object.values(croppedAreaPixels).some(isNaN)) {
      setErrorMessage('Invalid crop area detected. Please try re-cropping.');
      console.error('CroppedAreaPixels contains NaN values:', croppedAreaPixels);
      return;
    }
    try {
      const blob = await getCroppedImg(imageURL, croppedAreaPixels);
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        if (!checkBase64Size(base64data)) {
          setErrorMessage('Cropped image size should be less than 900 KB.');
          setCroppedImageBase64(null);
        } else {
          setCroppedImageBase64(base64data); // Store the Base64 string for preview
          setErrorMessage('');
        }
      };
      reader.onerror = (error) => {
        console.error('FileReader error:', error);
        setErrorMessage('Failed to read cropped image data.');
      };
    } catch (error) {
      console.error('Crop failed:', error);
      setErrorMessage('படத்தை வெட்ட முடியவில்லை');
    }
  }, [imageURL, croppedAreaPixels]);

  if (!family) {
    return (
      <>
        <Navbar />
        <Helmet>
          <title>உறுப்பினர் விவரங்களைப் புதுப்பிக்கவும்</title>
        </Helmet>
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }


  return (
    <>
      <Navbar />
      <Helmet>
        <title>உறுப்பினர் விவரங்களைப் புதுப்பிக்கவும்</title>
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h2>உறுப்பினர் விவரங்களைப் புதுப்பிக்கவும்</h2>
            <br />
            {/* Member Selector */}
            <div className="detail-item">
              <label className="detail-label">குடும்ப உறுப்பினரைத் தேர்ந்தெடுக்கவும்</label>
              <select
                onChange={(e) => {
                  const selected = family.members.find(m => m.uid === e.target.value);
                  setFamilyMember(selected);
                  setSelectedYear("");
                  setImageFile(null);
                  setCroppedImageBase64(null);

                  // Reset form with member's existing data
                  // Call reset for each form instance with the specific data
                  resetMobile({ mobile: selected?.mobile || "" });
                  resetMobile2({ mobile2: selected?.mobile2 || "" });
                  resetEmail({ email: selected?.email || "" });
                  resetDOB({ dob: selected?.dob || "" });
                }}
                className='auth_select'
              >
                <option value="">-- உறுப்பினரைத் தேர்ந்தெடுக்கவும் --</option>
                {family.members?.map((m, idx) => (
                  <option key={idx} value={m.uid}>
                    {m.firstName + '(' + m.aadhar + ')'}
                  </option>
                ))}
              </select>
            </div>

            {familyMember && (
              <div className="table-container">
                <table className="table">
                  <thead>

                  </thead>
                  <tbody>


                    <tr>
                      {/* Mobile */}

                      <td>
                        <span className="detail-label">பெயர்:</span>
                      </td>
                      <td>
                        <span>{familyMember.firstName || ""}</span>
                      </td>

                    </tr>

                    <tr>
                      <td>
                        <span className="detail-label">தந்தை / கணவர் பெயர்:</span>
                      </td>
                      <td>
                        <span>{familyMember.lastName || ""}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span className="detail-label">வணிக பெயர்:</span>
                      </td>
                      <td>
                        <span>{getBusinessLabel(familyMember.businessName)}</span>
                      </td>
                    </tr>
                    <tr>
                      {/* Mobile */}

                      <td>
                        <label className="detail-label">கைபேசி எண்:</label>
                      </td>
                      <td>
                        {familyMember.mobile && !isSubmittingMobile ? (
                          <span>{familyMember.mobile}</span>
                        ) : (
                          <form onSubmit={handleSubmitMobile(updateMobile)}>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <input
                                type="tel"
                                {...registerMobile("mobile",
                                  {
                                    required: "மொபைல் எண் தேவை",
                                    pattern: { value: /^\d{10}$/, message: "சரியான 10 இலக்க மொபைல் எண் உள்ளிடவும்" }
                                  }
                                )
                                }
                                className="auth_input"
                              />
                              {errorsMobile.mobile && <p>{errorsMobile.mobile.message}</p>}
                              <button type="submit" disabled={loading || !isValidMobile || isSubmittingMobile}
                                className={`auth_submit ${!isValidMobile || isSubmittingMobile ? "disabled_btn" : ""}`}
                              >சேமிக்கவும்</button>
                            </div>
                          </form>
                        )}
                      </td>

                    </tr>
                    <tr>

                      {/* Mobile 2 */}

                      <td>

                        <label className="detail-label">கைபேசி எண் 2:</label>
                      </td>
                      <td>
                        {familyMember.mobile2 && !isSubmittingMobile2 ? (
                          <span>{familyMember.mobile2}</span>
                        ) : (
                          <form onSubmit={handleSubmitMobile2(updateMobile2)}>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <input type="tel"
                                {...registerMobile2("mobile2", {
                                  required: "மொபைல் எண் தேவை",
                                  pattern: { value: /^\d{10}$/, message: "சரியான 10 இலக்க மொபைல் எண் உள்ளிடவும்" }
                                })}
                                className="auth_input" />
                              {errorsMobile2.mobile2 && <p>{errorsMobile2.mobile2.message}</p>}
                              <button type="submit" disabled={loading || !isValidMobile2 || isSubmittingMobile2}
                                className={`auth_submit ${!isValidMobile2 || isSubmittingMobile2 ? "disabled_btn" : ""}`}
                              >சேமிக்கவும்</button>
                            </div>
                          </form>
                        )}
                      </td>

                    </tr>
                    <tr>
                      {/* Email */}


                      <td>

                        <label className="detail-label">மின்னஞ்சல்:</label>
                      </td>
                      <td>
                        {familyMember.email && !isSubmittingEmail ? (
                          <span>{familyMember.email}</span>
                        ) : (

                          <form onSubmit={handleSubmitEmail(updateEmail)}>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <input type="email"
                                {...registerEmail("email",
                                  {
                                    required: "மின்னஞ்சல் தேவை",
                                    pattern: {
                                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                      message: "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்"
                                    }
                                  })
                                }
                                className="auth_input" />
                              {errorsEmail.email && <p>{errorsEmail.email.message}</p>}
                              <button type="submit" disabled={loading || !isValidEmail || isSubmittingEmail}
                                className={`auth_submit ${!isValidEmail || isSubmittingEmail ? "disabled_btn" : ""}`}>சேமிக்கவும்</button>
                            </div>
                          </form>

                        )}
                      </td>

                    </tr>
                    <tr>
                      {/* DOB */}

                      <td>

                        <label className="detail-label">வயது:</label>
                      </td>
                      <td>
                        {familyMember.dob && !isSubmittingDOB ? (

                          <span>

                            {familyMember.dob ? ` ${getAge(familyMember.dob)}` : ""}
                          </span>
                        ) : (
                          <form onSubmit={handleSubmitDOB(updateDOB)}>

                            <div style={{ display: "flex", gap: "10px" }}>
                              {/* Year dropdown */}
                              <select
                                onChange={handleYearChange}
                                value={selectedYear}
                                className="auth_select"
                              >
                                <option value="">ஆண்டு தேர்வு செய்யவும்</option>
                                {getYearOptions(1940).map((year) => (
                                  <option key={year} value={year}>{year}</option>
                                ))}
                              </select>

                              <input
                                type="date"
                                id="dob"
                                ref={dateInputRef}
                                {...registerDOB("dob", {
                                  required: "பிறந்த தேதி தேவை"
                                })}
                                className="auth_input"
                              />
                              {errorsDOB.dob && <p>{errorsDOB.dob.message}</p>}
                              <button type="submit" disabled={loading || !isValidDOB || isSubmittingDOB}
                                className={`auth_submit ${!isValidDOB || isSubmittingDOB ? "disabled_btn" : ""}`}
                              >சேமிக்கவும்</button>
                            </div>
                          </form>
                        )}
                      </td>

                    </tr>
                    <tr>
                      {/* Photo */}


                      <td>

                        <label className="detail-label">புகைப்படம்:</label>
                      </td>
                      <td>
                        {familyMember.photoPath ? (
                          <img src={familyMember.photoPath?.signedUrl} alt="Member" width="100" />
                        ) : (<>
                          <div className="auth_element">
                            <label className="auth_label"></label>
                            <input
                              type="file"
                              id="applicationFormFile"
                              accept="image/*"
                              onChange={handleImageSelect}
                              className="auth_input"
                            />
                            {errorMessage && <div className="auth_error">{errorMessage}</div>}

                            <p className="text-sm text-gray-700 mb-2">
                              📸 <strong>புகைப்படம் 1MB-ஐ விட பெரியதாக இருந்தால்:</strong><br />
                              1. Screenshot எடுத்து<br />
                              2. WhatsApp-இல் HD இல்லாமல் அனுப்பி<br />
                              3. மீண்டும் Save செய்து<br />
                              4. இங்கே Upload செய்யவும்.
                            </p>
                          </div>


                          {/* Display Cropper only if image is uploaded AND uploadMode is 'both' */}
                          {imageFile && uploadMode === 'both' && (
                            <div className="auth_element" style={{ padding: '16px', border: '1px dashed #ccc', marginBottom: '16px' }}>
                              {/* Aspect Ratio Lock Toggle */}

                              {/* Use the responsive container classes from crop.css */}
                              <div className="cropper-container-wrapper">
                                <div className="cropper-inner-container">
                                  {imageURL && (
                                    <Cropper
                                      image={imageURL}
                                      crop={crop}
                                      zoom={zoom}
                                      onCropChange={setCrop}
                                      onZoomChange={setZoom}
                                      onCropComplete={onCropComplete}

                                      aspect={isAspectRatioLocked ? 2.5 / 3 : undefined}
                                      cropShape="rect"
                                      showGrid={true}

                                    />
                                  )}
                                </div>
                              </div>
                              <div style={{ marginTop: '20px' }}>
                                <label htmlFor="zoom-range" className="block text-sm font-medium text-gray-700">Zoom:</label>
                                <input
                                  id="zoom-range"
                                  type="range"
                                  min={1}
                                  max={10}
                                  step={0.1}
                                  value={zoom}
                                  onChange={(e) => setZoom(parseFloat(e.target.value))}
                                  className="w-full mb-4"
                                />
                              </div>
                              <button
                                type="button"
                                onClick={handleCrop}
                                className="action-button"
                              >
                                ✂️ புகைப்படத்தைத் தேர்ந்தெடுக்கவும்
                              </button>
                            </div>
                          )}
                          {/* Display Cropped Image Preview */}
                          {croppedImageBase64 && uploadMode === 'both' && (
                            <>
                              <div className="auth_element">
                                <p className="text-gray-700 font-semibold mb-2">🔍 புகைப்பட முன்னோட்டம்:</p>
                              </div>
                              <img
                                src={croppedImageBase64}
                                alt="புகைப்பட முன்னோட்டம்"
                                style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover', border: '1px solid #ccc', padding: '4px' }}
                              />
                            </>
                          )}
                          {croppedImageBase64 && uploadMode === 'both' && (
                            <button
                              type="button"
                              onClick={updatePhoto}
                              className={`auth_submit ${loading ? "disabled_btn" : ""}`}
                              disabled={loading} // Only disable on loading state
                              style={{ marginTop: '10px' }}
                            >
                              📤 புகைப்படத்தை பதிவேற்றவும்
                            </button>
                          )}
                        </>
                        )}
                      </td>

                    </tr>

                  </tbody>
                </table>
              </div>
            )}

            <br />
            <div style={{ marginTop: "30px", textAlign: "center", fontSize: "14px", color: "#555" }}>
              <p>
                ⚠️ உங்கள் தகவல்களை புதுப்பிக்க முடியவில்லை என்றால்,
                <br />
                தயவுசெய்து கீழ்காணும் மின்னஞ்சலுக்கு தொடர்பு கொள்ளவும்.
                <br />
                <strong>தயவுசெய்து உங்கள் பிரச்சனை குறித்த ஸ்கிரீன்‌ஷாட்டையும் இணைக்கவும்.</strong>
                <br />
                <a
                  href="mailto:sriponnachiammantemples@gmail.com?subject=தகவல்%20புதுப்பிக்க%20முடியவில்லை&body=வணக்கம்,%20எனது%20தகவல்களை%20புதுப்பிக்க%20முடியவில்லை.%20தயவுசெய்து%20உதவி%20செய்யவும்."
                  style={{ color: "#007bff", textDecoration: "none" }}
                >
                  📧 sriponnachiammantemples@gmail.com
                </a>
              </p>
            </div>

          </div>
        </div>
      </div >

      <Footer />
    </>
  );
}
export default UserFamilyMissingInfoUpdate;
